import { Pipe, PipeTransform } from '@angular/core';
import { transformAttributeService } from '../services/transform-attribute-service';

@Pipe({
  name: 'absoluteValue',
  standalone: true,
})
export class AbsoluteValuePipe implements PipeTransform {
  constructor(private transformAttributeService: transformAttributeService) {}
  transform(value: number): number {
    return this.transformAttributeService.absoluteValue(value);
  }
}
